import type { FC, ReactNode } from 'react';
import { HashLink } from 'react-router-hash-link';
import { Link } from '@mui/material';
import { useSetAtom } from 'jotai';

import { dashboardHiddenSections } from 'src/components/dashboard/DashboardPage/atom';
import { getInternalLinkHandler } from 'src/components/dashboard/DashboardPage/components/WidgetWrapper/helper';

import { styles } from './widgetHashLink.styles';

interface WidgetHashLinkProps {
  internalLink?: number | null;
  children: ReactNode;
}

const WidgetHashLink: FC<WidgetHashLinkProps> = ({
  internalLink,
  children,
}) => {
  const setHiddenSections = useSetAtom(dashboardHiddenSections);
  const internalLinkHandler = getInternalLinkHandler(setHiddenSections);
  return internalLink ? (
    <Link
      component={HashLink}
      to={`#widget-${internalLink}`}
      smooth
      scroll={internalLinkHandler}
      sx={styles.widgetLink}
    >
      {children}
    </Link>
  ) : (
    <>{children}</>
  );
};

export default WidgetHashLink;
